export default __webpack_public_path__ + "ed313702ca4650a1cd0a99a4bcc38894.svg";